import download_component from '#BASE/components/downLoad/DownLoadCenter';
import AFK_component from '#BASE/components/downLoad/AFK';
import { actionTypes } from 'BASE/store/types';
export default {
    mixins: [AFK_component, download_component],
    data: function () {
        return {
            QrcodeOptions: {
                width: 170,
                margin: 1
            },

            AppDownloadShow: false,
            SwitchToApp: true,
            ShowAPPBlock: false,
            ShowAFKBlock: false,
            ShowCenterAFKBlock: false,
            ShowLegendBlock: false,
            SaveStorage:false,
        };
    },
    methods: {
        switchPage(showDownloadPage) {
            this.SwitchToApp = showDownloadPage;
        },
        windowOpen(url) {
            window.open(url, "_blank")
        },
        InitCallback() {
            // 需要實作的再實作
        },
        async GetAfkConfig(){
            return await $.post('/api/AFK/GetAFKConfig');
        },
        async Init() { }, // 同時引用AFK_component、download_component Init()會POST兩次/api/AFK/GetAFKConfig，重做一個Init
        async Init2() {
            let _this = this;
            try {
                let result = await this.GetAfkConfig();
                if (result) {
                    if (result.IOSPlistPath && result.IOSPlistPath.indexOf(".plist") === -1) {
                        _this.iosUrl = result.IOSPlistPath;
                    }

                    if (result.AndroidAPPUrl) {
                        _this.androidUrl = result.AndroidAPPUrl;
                    }
                    else if (result.AndroidAPPFile) {
                        _this.androidUrl = _this.FileName(result.AndroidAPPFile);
                    }

                    if (result.AFKAndroidUrl) {
                        _this.AFKAndroidUrl = result.AFKAndroidUrl;
                    }
                    else if (result.AFKAndroidFile) {
                        _this.AFKAndroidUrl = _this.FileName(result.AFKAndroidFile);
                    }

                    if (result.AFKiosUrl) {
                        _this.AFKiosUrl = result.AFKiosUrl;
                    }

                    if (result.AFKPcUrl) {
                        _this.AFKPcUrl = result.AFKPcUrl;
                    }
                    else if (result.AFKPcFile) {
                        _this.AFKPcUrl = _this.FileName(result.AFKPcFile);
                    }
                    if (result.AFKZCBPcUrl) {
                        _this.AFKZCBPcUrl = result.AFKZCBPcUrl;
                    }
                    else if (result.AFKZCBPcFile) {
                        _this.AFKZCBPcUrl = _this.FileName(result.AFKZCBPcFile);
                    }

                    if (result.LegendAFKAndroidUrl) {
                        _this.LegendAFKAndroidUrl = result.LegendAFKAndroidUrl;
                    }
                    else if (result.LegendAFKAndroidFile) {
                        _this.LegendAFKAndroidUrl = _this.FileName(result.LegendAFKAndroidFile);
                    }

                    if (result.LegendAFKiosUrl) {
                        _this.LegendAFKiosUrl = result.LegendAFKiosUrl;
                    }

                    if (result.LegendAFKPCUrl) {
                        _this.LegendAFKPCUrl = result.LegendAFKPCUrl;
                    }
                    else if (result.LegendAFKPCFile) {
                        _this.LegendAFKPCUrl = _this.FileName(result.LegendAFKPCFile);
                    }

                    if (result.LoginUrl) {
                        _this.LoginUrl = result.LoginUrl;
                    }

                    if (result.SmartAFKUrl) {
                        _this.SmartAFKUrl = result.SmartAFKUrl;
                    }

                    _this.ShowAPPBlock = _this.iosUrl != "" || _this.androidUrl != "";
                    _this.ShowAFKBlock = _this.AFKAndroidUrl != "" || _this.AFKiosUrl != "";
                    _this.ShowCenterAFKBlock= _this.AFKAndroidUrl != "" || _this.AFKiosUrl != "" || _this.AFKZCBPcUrl != "";
                    _this.ShowLegendBlock = _this.LegendAFKAndroidUrl != "" || _this.LegendAFKiosUrl != "";
                    _this.SwitchToApp = _this.ShowAPPBlock;

                    _this.InitCallback();
                    if(this.SaveStorage)
                        this.$store.dispatch(actionTypes.AFK_URL_SET, { afkUrlSet: result });
                    _this.$emit("ShowSetting", _this.ShowAPPBlock, _this.ShowAFKBlock);
                }
            }
            catch (err) {
                console.error(err);
            }
        },
    },
    async mounted() {
        await this.Init2();
    }
}